import * as React from "react";

import SandboxContext, {
    type SandboxContext as SandboxContextType,
} from "../internal/sandbox-context.ts";

export const useSandboxContext = (): SandboxContextType => {
    return React.useContext(SandboxContext);
};
